require.register("documenteditor/controllers/lodEntriesCtrl", function(exports, require, module){
  $0
  
});

